import { useContext } from 'react';

import { styled } from 'twin.macro';

import { CorePermissions, ProductType } from '@/core/api/collections/users';
import { AuthContext } from '@/core/auth/AuthContext';
import { UserInviteContext } from '@/core/users/UserInvite/UserInviteContext';
import { DEFAULT_CORE_PERMISSIONS, ERROR_NOT_AN_ADMIN } from '@/core/users/UserPermissions/constants';
import { EditPermissions } from '@/core/users/UserPermissions/EditPermissions';

export function UserInviteEditPermissionsContainer () {
  const { currentUser, hasCoreAccess, hasUvkAccess } = useContext(AuthContext);
  const { inviteParams, setInviteParams } = useContext(UserInviteContext);

  function setCorePermission<K extends keyof CorePermissions>(key: K, value: CorePermissions[K]) {
    if (inviteParams.core) {
      inviteParams.core[key] = value;
      setInviteParams(inviteParams);
    }
  }

  const doToggleAccess = (product: ProductType) => {
    const key = product === 'discovery' ? 'core' : 'uvk';
    if (inviteParams[key]) {
      inviteParams[key] = undefined;
    } else {
      if (key === 'core') {
        inviteParams[key] = DEFAULT_CORE_PERMISSIONS;
      } else {
        inviteParams[key] = { enabled: true, admin: true, state: 'invited' };
      }
    }
    setInviteParams(inviteParams);
  };

  return (
    <StyledEditPermissionsContainer $hidePermissionToggle={!(hasCoreAccess && hasUvkAccess)}>
      <EditPermissions
        permissions={{ core: inviteParams.core, uvk: inviteParams.uvk }}
        coreDisabledMessage={currentUser?.coreOwner ? undefined : ERROR_NOT_AN_ADMIN}
        uvkDisabledMessage={currentUser?.uvkAdmin ? undefined : ERROR_NOT_AN_ADMIN}
        onCorePermissionChanged={setCorePermission}
        toggleAccess={doToggleAccess}
      />
    </StyledEditPermissionsContainer>
  );
}

// If the account only has access to one product, you shouldn't be able to disable that product during the invite process
const StyledEditPermissionsContainer = styled.div<{ $hidePermissionToggle?: boolean }>`
  ${({ $hidePermissionToggle }) => $hidePermissionToggle ? `
    .permission-group-toggle {
      display: none;
    }
  ` : ''}
`;
